import React, { useEffect, useState } from 'react';
import '../style/AnnouncementBanner.css';

const API = process.env.REACT_APP_API_URL || '';

export default function AnnouncementBanner() {
    const [announcements, setAnnouncements] = useState([]);
    const [dismissed, setDismissed]         = useState(() => {
        try { return JSON.parse(sessionStorage.getItem('dismissed_announcements') || '[]'); }
        catch { return []; }
    });

    useEffect(() => {
        fetch(`${API}/api/announcements`)
            .then(res => res.ok ? res.json() : [])
            .then(data => setAnnouncements(Array.isArray(data) ? data : []))
            .catch(() => {});
    }, []);

    const dismiss = (id) => {
        const next = [...dismissed, id];
        setDismissed(next);
        try { sessionStorage.setItem('dismissed_announcements', JSON.stringify(next)); } catch {}
    };

    const visible = announcements.filter(a => !dismissed.includes(a.id));
    if (visible.length === 0) return null;

    return (
        <div className="announcement-stack">
            {visible.map(a => (
                <div key={a.id} className={`announcement-banner announcement-${a.type.toLowerCase()}`}>
                    <div className="announcement-inner">
                        <span className="announcement-icon">
                            {a.type === 'ALERT' ? '⚠️' : a.type === 'PROMO' ? '🎉' : 'ℹ️'}
                        </span>
                        <div className="announcement-text">
                            <strong className="announcement-title">{a.title}</strong>
                            <span className="announcement-msg">{a.message}</span>
                        </div>
                        <button
                            className="announcement-close"
                            onClick={() => dismiss(a.id)}
                            aria-label="Dismiss"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}
